require('./brokerHireAlternativeInvestmentFundSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const momentTz = require('moment-timezone');
// @ components
const BrokerHireAlternativeInvestmentFundDetails = require('../brokerHireAlternativeInvestmentFundDetails/brokerHireAlternativeInvestmentFundDetails');
// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const { DATE_FORMAT_COMPLETE, BROKER_MYPROFILE_MYWALLET_URL } = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/brokerHireAlternativeInvestmentFund.tracking');
const { PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME } = require("utilities/tagging");
// @ utilities
const { recordLinkV2 } = require("utilities/tagging");
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { recordPage } = require('utilities/tagging.js')
class BrokerHireAlternativeInvestmentFundSuccess extends React.Component {

  componentDidMount() {
      const { immInvestmentFunds } = this.props;
        recordLinkV2(catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_SUCCESS]());
        taggingEventHandled(PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME, 'successPage' );

        const isin = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'isin']);     
        const customData = {
          event_name: "step_success",
          pageName: "/buyAlternativeFunds/success",
          sectionFamily: "wealth",
          sectionCategory: "products",
          sectionName: "funds",
          serviceType: "productContracting",
          interactionType: "funnel",
          processType: "buyAlternativeFunds",
          processStep: "success",
          productName: isin,
        };
        recordPage(customData)

    }

    buildColumns() {
        const baseColumns = ['account', 'brokerAlternativeFundsBuySuccess-amount'];
        let columns;
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            columns = [
                'brokerAlternativeFundsBuySuccess-aplicationDate',
                'brokerAlternativeFundsBuySuccess-subscriptionFund',
                ...baseColumns
            ];
        } else {
            columns = [
                'brokerAlternativeFundsBuySuccess-date',
                'brokerAlternativeFundsBuySuccess-destinationFund',
                ...baseColumns
            ];
        }
        return columns;
    }

    buildMessage() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            return formatText('brokerAlternativeFundsBuySuccess-successMessageSubs');
        } else {
            return formatText('brokerAlternativeFundsBuySuccess-successMessage');
        }
    }

    render() {
        const { immInvestmentFunds, immAccounts } = this.props;
        const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currencyObject = {
            amount: immInvestmentFunds.getIn(['steps', 0, 'amount']),
            currency: immAccount.getIn(['balance', 'currency'])
        };
        const amountInvestment = getFormattedString(currencyObject);
        let columnsContent = [
            momentTz().tz("Europe/Madrid").format(DATE_FORMAT_COMPLETE),
            fundName,
            'account',
            amountInvestment
        ];
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            const liquidAmount = immInvestmentFunds.getIn(['subscriptionFund', 'liquidAmount']);
            const liquidAmountText = getFormattedString(liquidAmount);
            columnsContent.push(liquidAmountText);
        }

        const columns = this.buildColumns();
        const successMessage = this.buildMessage();

        return (
          <div className="hire-investment-success">
            <WizardSuccess
              customClassName="hire-investment-success__container"
              successMessage={successMessage}
              processDetail={immInvestmentFunds.getIn(['investmentFunds', 'isin'])}
              tealium={catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_SUCCESS]({
                productName: immInvestmentFunds.getIn(['investmentFunds', 'isin']),
              })}
            >
              <div className="account-debits-return-success__actions text-right" />
            </WizardSuccess>
            <div className="hire-investment-success__details">
              <FormattedText value="brokerAlternativeFundsBuySuccess-details" />
            </div>
            <BrokerHireAlternativeInvestmentFundDetails
              columns={columns}
              columnsContent={columnsContent}
              immAccount={immAccount}
              immInvestmentFunds={immInvestmentFunds}
            />
            <div className="hire-investment-success__buttons">
              <section className="steps-to-hire">
                <div className="container-title">
                  <FormattedText
                    value="brokerAlternativeFundsBuySuccess-steps_title"
                    className="title-text"
                  />
                </div>
                <div className="steps-container">
                  <div className="step">
                  <div className= "step1-img" />
                    <FormattedText
                      value="brokerAlternativeFundsBuySuccess-step1_title"
                      className="title-text"
                    />
                    <FormattedText
                      value="brokerAlternativeFundsBuySuccess-step1_description"
                      className="description-text"
                    />
                  </div>
                  <div className="step">
                  <div className= "step2-img" />
                    <FormattedText
                      value="brokerAlternativeFundsBuySuccess-step2_title"
                      className="title-text"
                    />
                    <FormattedText
                      value="brokerAlternativeFundsBuySuccess-step2_description"
                      className="description-text"
                    />
                    <div className="content"></div>
                  </div>
                  <div className="step">
                  <div className= "step3-img" />
                    <FormattedText
                      value="brokerAlternativeFundsBuySuccess-step3_title"
                      className="title-text"
                    />
                    <FormattedText
                      value="brokerAlternativeFundsBuySuccess-step3_description"
                      className="description-text"
                    />
                    <div className="content"></div>
                  </div>
                </div>
              </section>
              <div className="hire-investment-success__div-buttons-right">
                <div className="hire-investment-success__left-button">
                  <OKButton
                    modifier="ghost"
                    to={BROKER_MYPROFILE_MYWALLET_URL + '/ordersAndMovements'}
                  >
                    <FormattedText value="brokerAlternativeFundsBuySuccess-askMovements" />
                  </OKButton>
                </div>
                <OKButton modifier="secondary" to={BROKER_MYPROFILE_MYWALLET_URL}>
                  <FormattedText value="brokerAlternativeFundsBuySuccess-finish" />
                </OKButton>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        );
    }
}

BrokerHireAlternativeInvestmentFundSuccess.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired
};

module.exports = BrokerHireAlternativeInvestmentFundSuccess;
